export default __webpack_public_path__ + "static/oil-tank-removal-single-84fd246f486e7f23025143a4e3610818.jpg";